/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DailyOrgSummaryPostSpec { 
    /**
     * max rwr cb protected vm count on usage_date
     */
    max_rwr_cb_vm_count?: number;
    /**
     * max rwr cs protected vm count on usage_date
     */
    max_rwr_cs_vm_count?: number;
    /**
     * max rwr protected vm count on usage_date
     */
    max_rwr_vm_count?: number;
    /**
     * actual max tibs used for AP datacenter on usage_date
     */
    max_tib_usage_ap?: number;
    /**
     * actual max tibs used for EM datacenter on usage_date
     */
    max_tib_usage_em?: number;
    /**
     * actual max tibs used for LT datacenter on usage_date
     */
    max_tib_usage_lt?: number;
    /**
     * actual max tibs used for US datacenter on usage_date
     */
    max_tib_usage_us?: number;
    /**
     * actual max vm usage on usage_date across datacenters
     */
    max_vm_usage?: number;
    /**
     * actual max svm usage on usage_date across datacenters
     */
    max_svm_usage?: number;
    /**
     * max tibs overage for AP datacenter on usage_date
     */
    overage_tib_usage_ap?: number;
    /**
     * max tibs overage for EM datacenter on usage_date
     */
    overage_tib_usage_em?: number;
    /**
     * max tibs overage for LT datacenter on usage_date
     */
    overage_tib_usage_lt?: number;
    /**
     * max tibs overage for US datacenter on usage_date
     */
    overage_tib_usage_us?: number;
    /**
     * max vm overage on usage_date
     */
    overage_vm_usage?: number;
    /**
     * max svm overage on usage_date
     */
    overage_svm_usage?: number;
    /**
     * tib subscription quantity for AP on usage_date
     */
    tib_subscription_ap?: number;
    /**
     * tib subscription quantity for EM on usage_date
     */
    tib_subscription_em?: number;
    /**
     * tib subscription quantity for LT on usage_date
     */
    tib_subscription_lt?: number;
    /**
     * tib subscription quantity for US on usage_date
     */
    tib_subscription_us?: number;
    /**
     * vm subscription quantity on usage_date
     */
    vm_subscription_quantity?: number;
    /**
     * svm subscription quantity on usage_date
     */
    svm_subscription_quantity?: number;
    /**
     * CSP service type value.
     */
    csp_service_type: string;
    org_id: string;
    /**
     * Date of the usage in YYYY-MM-DD.
     */
    usage_date: string;
}

